export interface RepaymentPageRequest {
    cameraId?: string
    cancelTimeBegin?: string
    cancelTimeEnd?: string
    current: number
    customerName?: string
    finishTimeBegin?: string
    finishTimeEnd?: string
    productId?: number
    repayState?: string
    rid?: number
    shouldTimeBegin?: string
    shouldTimeEnd?: string
    size: number
    tenantId?: number
    lid?: number
}

export interface RepaymentRequest {
    tenantId?: number
    lid: number
}

export interface RepaymentPageRecord {
    cameraId: number
    createTime: string
    customerId: number
    factCapital: number
    factFine: number
    factInterest: number
    factOtherTotalFee: number
    factOverdueFee: number
    factTime: number
    finishTime: string
    indexs: number
    lid: number
    productId: number
    productVersion: string
    rid: number
    ridStr: string
    shouldCapital: number
    shouldFine: number
    shouldInterest: number
    shouldOtherTotalFee: number
    shouldOverdueFee: number
    shouldTime: string
    state: number
    subtractFine: number
    subtractOverdueFee: number
    taskStatus: number
    tenantId: number
    timeStatus: number
    updateTime: string
    cameraIdStr: string
}

export interface CollectionRequest {
    mid: number,
    cameraId: number,
    remark: string
}

export interface PartRepaymentRequest {
    lid: number
    tenantId?: number
    indexs?: number
}

export interface LoanRepaymentRequest extends PartRepaymentRequest {
    capitalAmount?: number
    factTime?: number
    feesAmount?: number
    indexs?: number
    interestAmount?: number
    paidAmount: number
    penaltyAmount?: number
    remark?: string
    type?: number
    bizId?: number
    userId?: number
    userName?: string
}

export interface VietRepaymentRequest extends PartRepaymentRequest {
    capitalAmount: number
    factTime: number
    interestFeeAmount: number
    paidAmount: number
    penaltyOverdueAmount: number
    remark: string
    repaymentAction: number
    subtractFineStatus: number
    userId: number
}

export interface PartRepaymentData {
    capitalAmount: number
    clearAmount: number
    enjoyAmount: number
    factOverdueFee: number
    feesAmount: number
    indexs: number
    interestAmount: number
    lid: number
    paidAmount: number
    penaltyAmount
    totalAmount: number
    unpaidAmount: number
    inputAmount?: number
    timeStatus: number
}

export interface LoanRepaymentDetail {
    cameraId: number
    createTime: string
    customerId: number
    factCapital: number
    factFeeAmount: number
    factFine: number
    factInterest: number
    factOverdueFee: number
    factTime: number
    id: number
    lid: number
    rid: number
    tenantId: number
    updateTime: string
    remark: string
}

export interface LoanRepaymentSubstractRecord {
    operator: string
    createTime: string
    totalAmount: number
    capitalAmount: number
    interestAmount: number
    penaltyAmount: number
    feesAmount: number
    remark: string
}

export interface RepaymentDetailRequest {
    index: number
    lid: number
    rid: number
    tenantId?: number
}

export interface RepaymentDetailResponse {
    list: LoanRepaymentDetail[]
    partRepaymentResponse: PartRepaymentData
}

export interface PenaltyFineRequest {
    beginTime?: string
    cameraId?: string
    current: number
    endTime?: string
    rid?: number
    size: number
    tenantId?: number
}

export interface PenaltyFinePageRecord {
    cameraId: number
    customerId: string
    customerName: string
    did: string
    factFine: number
    indexs: number
    lid: string
    productId: string
    productName: string
    productVersion: string
    rid: string
    shouldFine: number
    shouldTime: string
    state: number
    cameraIdStr: string
}

export interface TallyBillApproveRecordRequest {
    bizId?: number
    current: number
    size: number
    tenantId?: number
}

export interface TallyBillApproveRecord {
    tallyBillType: number
    repaymentAmount: number
    repaymentVoucher: string
    bizId: number
    status: number
    createUserName: string
    updateUserName: string
    createUser: number
    updateUser: number
    mid: number
    lid: number
    indexs: number
    shouldTime: string
    factTime: string
    tenantId: number
    rid: number
}

export interface PayRequestRecordRequest {
    thirdOrderNo: string
    current: number
    size: number
    tenantId?: number,
    channelId: number,
    status: number
}

export interface PayRequestRecord {
    id: number
    channelId: number
    payType: number
    thirdOrderNo: string
    reqThirdBody: string
    respThridBody: string
    status:number
    tenantId: number
    rtcode: string
    rtmsg: string
}
export enum RepaymentState {
    UNPAID,
    NORMAL,
    OVERDUE,
    AFTER_OVERDUE,
    PARTIAL,
    AFTER_PARTIAL,
    MANUAL,
    CANCEL
}

export enum TallyBillState {
    WAIT_APPROVE = 1,
    FINISH_APPROVE = 2,
    CANCEL_APPROVE = 3
}

export enum ChannelList {
    STP = 4,
    conektaPay = 6,
    openPay = 2
}

export enum RequestType {
    REQUEST = 1,
    SEARCH = 2,
    CALL = 3
}

export enum PayRequestRecordStatus {
    NoHandle = 0,
    Processed = 1,
    FAIL = 2
}

export enum DataSource {
    thirdCall = 0,
    handImport = 1
}

export enum TallyBillType {
    INBURSA_REPAYMENT = 1,
    OVERDUE_REPAYMENT = 2
}

export enum IsExtends {
    NOT_EXTENDS,
    EXTENDING,
    EXTENDSUCCESS
}

export enum DoubleLoan {
    FIRST,
    DOUBLE
}

export enum PersonalOperate {
    SELF,
    ALL
}

export interface LoanRepaymentSubstractRequest {
    lid: number
    totalAmount: number
    capitalAmount?: number
    interestAmount?: number
    penaltyAmount?: number
    feesAmount?: number
    remark?: string
    indexs?: number
}

export interface CalculationToFactTimeParams {
    factTime?: number
    indexs?: number
    lid: number
    rid: number
    tenantId: number
}

export interface CalculationToFactTimeRecord {
    amount: number
    calcAmount: number
    capitalAmount: number
    clearAmount: number
    enjoyAmount: number
    factTime: number
    feesAmount: number
    indexs: number
    interestAmount: number
    lid: number
    overdueFee: number
    paidAmount: number
    penaltyAmount: number
    rid: number
    tenantId: number
    totalAmount: number
    unpaidAmount: number
}

export interface CalculationExtendsRequest {
    lid: number
    tenantId?: number
    indexs?: number
}

export interface CalculationExtendsResponse extends PartRepaymentData {
    tenantId: number
    extendsAmount: number
    extendsShouldAmount: number
    factAmount: number
    capitalAmount: number
    unpaidAmount: number
    extendsFee: number
}

export interface UpdateRepaymentDetailRemarkRequest {
    id: number
    remark: string
}
